import React from "react";

/* ── Main Component ── */

const TopBottomImgContent = ({ section, columns = 3, align = "center" }) => {
  if (!section) return null;

  const { items = [] } = section;

  return (
    <div className="w-full mx-auto px-4">
      <div className="flex flex-wrap justify-center gap-6">
        {items.map((item, index) => (
          <div
            key={item.id || index}
            className={`
          w-full 
          sm:basis-[calc(50%-0.75rem)] 
          md:basis-[calc(50%-0.75rem)]
          
          ${columns === 5 ? "lg:basis-[calc(32%-1rem)]" : ""}
          ${columns === 4 ? "lg:basis-[calc(32%-1rem)]" : ""}
          ${columns === 3 ? "lg:basis-[calc(33.333%-1rem)]" : ""}
          flex justify-center
        `}
          >
            <ServiceCard item={item} align={align} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopBottomImgContent;

/* ── Card Component ── */

const ServiceCard = ({ item, align }) => {
  const textAlign =
    align === "left"
      ? "text-left items-start"
      : align === "right"
        ? "text-right items-end"
        : "text-center items-center";

  return (
    <div className="bg-[#F1F3FF] shadow-sm rounded-[10px] rounded-tl-none flex flex-col overflow-hidden w-full xl:max-w-[420px] lg:my-5">
      {/* Image */}

      <img
        src={item.image}
        alt={item.label || item.title}
        className="w-full h-[28vh] md:h-full lg:h-[32.5vh] xl:h-[30.5vh] object-cover transition-transform duration-500 group-hover:scale-105"
      />

      {/* Content */}
      <div className="relative group pt-10 px-4 pb-4">
        {item.title && (
          <div
            className="absolute top-0 left-0 px-4 py-2 text-white rounded-br-[10px]"
            style={{ backgroundColor: "var(--primary-color)" }}
          >
            {item.title}
          </div>
        )}

        <div className={`space-y-2 text-left mt-3`}>
          {item.list?.map((point, i) => (
            <p key={i} className="text-gray-700">
              {point}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};
